// tslint:disable

import { get } from 'lodash';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { IriField } from '../../components/fields/iri.field';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class DefaultModalCompanyAdmin extends React.Component<any, any> {
    public state: any = {
        company: null,
        selectedCompany: null,
        selectedCompanySiteSpec: null
    };
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateEndPoint('company-admin');
        form.fields.companySiteSpec.registerField();
        form.fields.companySiteSpec.setValue(this.props.CONFIG.companySiteSpec);

        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="company-admin" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create new company admin' : 'Edit company admin'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title="Admin details" color="green" alwaysOpen={true}>
                    <div className="row">
                        <div className="col-xs-12">
                            <IriField
                                field={form.fields.personCompany}
                                forceQuery={{company: this.props.CONFIG.company, pagination: false}}
                                defaultValue={this.props.CONFIG ? `/person-company/${this.props.CONFIG.personCompany}` : ''}
                                defaultAll={true}
                                disabled={this.props.CONFIG && this.props.CONFIG.disabledPerson}
                                itemRender={(personCompany: any) =>
                                    <IriPresenter iri={get(personCompany, 'person.@id')} render={(person: any) =>
                                        get(person, 'firstName') + ' ' + get(person, 'surName')
                                    }/>
                                }
                            />

                            <CheckboxField field={form.fields.active}/>

                            <blockquote>
                                {/* #TODO */}
                                Ide jon egy ROLE selector [ROLE_ADMIN, ROLE_SUPER_ADMIN]
                            </blockquote>

                            <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                        </div>
                    </div>
                </ToggleBoxComponent>
            </div>}/>
        );
    }

}



// WEBPACK FOOTER //
// ./src/__templates/details/default.modal.company-admin.tsx